import Initials from '../initials.js';

export default class Permissions {

  constructor() {
    const permissions = document.querySelector('form.permissions');

    if (permissions) {
      this.roleEvents();
    }
  }

  addMember() {
    const initials = new Initials();
    const name = document.querySelector('#name').value;
    const icon = '<div class="default-avatar mx-auto color-avatar rounded-circle d-flex align-items-center justify-content-center text-uppercase" style="background-color: ' + initials.initialsToColor(name) + ' ">' + name.slice(0,1) +'</div>';
    const id = document.querySelector('#hiddenId').value;
    const role = document.querySelector('#role').value;
    const mappersVal = document.querySelector('#mappers').value;

    if (id) {
      var optionText = '<option ';
      if (role == "view")
        optionText += 'selected="selected"';
      optionText += ' value="view">View</option><option ';
      if (role == "editor")
        optionText += 'selected="selected"';
      optionText += ' value="editor">Editor</option><option ';
      if (role == "admin")
        optionText += 'selected="selected"';
      optionText += ' value="admin">Admin</option>';

      if (mappersVal.split(',').indexOf(id) == -1){
        const tr = document.createElement('tr');
        tr.setAttribute('data-id', id);
        let rowHtml = '<td>'+icon+'</td><td>'+name+'</td><td><select id="role_drop" class="form-control w-xs-100p w-sm-100">'+optionText+'</select></td>';
        rowHtml += '<td class="text-right"><i role="button" class="far fa-trash-alt pe-3 js-object-delete"></i></td>';
        tr.innerHTML = rowHtml;
        document.querySelector('#grid_permissions tbody').appendChild(tr);
        new Permissions().calculateMaps();
        document.querySelector('#name').value = '';
        document.querySelector('#hiddenId').value = '';

      } else {
        document.querySelector('#feedback2').style.display = 'block';
      }

      document.querySelector('.pagination-container').style.display = 'none';
      if (document.querySelector('.no-data-row')) document.querySelector('.no-data-row').style.display = 'none';
    }
  }

  roleEvents() {
    const self = this;
    const addRole = document.querySelector('.add-permission');
    const changeRole = document.querySelector('#role_drop');
    const gridPermissions = document.querySelector('#grid_permissions');

    if (addRole) {
      addRole.addEventListener('click', self.addMember);
    }
    if (changeRole) {
      changeRole.addEventListener('change', self.calculateMaps);
    }

    // Remove Role
    if (gridPermissions) {
      gridPermissions.addEventListener('click', (e) => {
        const icon = e.target.closest('.js-object-delete');
        if (icon) {
          e.target.closest('tr').remove();
          document.querySelector('.pagination-container').style.display = 'none';
          self.calculateMaps();
        }
      });
    }
  }

  calculateMaps() {
    var values = [];
    var existingVals = [];

    const rows = document.querySelectorAll('#grid_permissions tbody tr');
    for (var i = 0; i < rows.length; i++) {
      const id = rows[i].getAttribute('data-id');
      if (id) {
        const roleSelect = rows[i].querySelector('#role_drop');
        var role = "";
        if (roleSelect) {
          role = roleSelect.value;
        }
        existingVals.push(id);
        values.push(id + "__" + role);
      }
    }

    document.querySelector('#mappers').value = existingVals.join(',');
    document.querySelector('#maps').value = values.join(',');
  }
}
